module.exports = "https://cdn-skillquest.mathletics.com/app/180/assets/images/e20eca2c983a31b66b8b865775c42dd7.svg";